import SvgImage from '@components/svg'
import {
  StyleActionButton,
  StyleActionButtonTitle,
  StyleActionIconButton,
  StyleRow,
} from './style'

interface TableActionProps {
  hasEdit?: boolean
  hasDelete?: boolean
  hasView?: boolean
  onEdit?: () => void
  onDelete?: () => void
  onView?: () => void
  type?: 'icon' | 'button'
  onCustom?: () => void
  hasCustom?: boolean
  customTitle?: string
}

const TableActions = ({
  hasEdit = true,
  hasDelete = true,
  hasView = true,
  onEdit,
  onDelete,
  onView,
  type = 'button',
  hasCustom = false,
  customTitle,
  onCustom,
}: TableActionProps) => {
  return (
    <StyleRow
      customStyle={{
        flexWrap: 'wrap',
        columnGap: 5,
        alignItems: 'center',
      }}
    >
      {!!hasCustom && (
        <StyleActionButton
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation()
            onCustom?.()
          }}
          type="button"
        >
          <StyleActionButtonTitle>{customTitle}</StyleActionButtonTitle>
        </StyleActionButton>
      )}
      {!!hasView && (
        <>
          {type === 'icon' && (
            <StyleActionIconButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onView?.()
              }}
              type="button"
            >
              <SvgImage src="eye" />
            </StyleActionIconButton>
          )}
          {type === 'button' && (
            <StyleActionButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onView?.()
              }}
              type="button"
            >
              <StyleActionButtonTitle>View</StyleActionButtonTitle>
            </StyleActionButton>
          )}
        </>
      )}
      {!!hasEdit && (
        <>
          {type === 'icon' && (
            <StyleActionIconButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onEdit?.()
              }}
              type="button"
            >
              <SvgImage src="editIcon" />
            </StyleActionIconButton>
          )}
          {type === 'button' && (
            <StyleActionButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onEdit?.()
              }}
              type="button"
            >
              <StyleActionButtonTitle>Edit</StyleActionButtonTitle>
            </StyleActionButton>
          )}
        </>
      )}
      {!!hasDelete && (
        <>
          {type === 'icon' && (
            <StyleActionIconButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onDelete?.()
              }}
              type="button"
            >
              <SvgImage src="deleteIcon" />
            </StyleActionIconButton>
          )}
          {type === 'button' && (
            <StyleActionButton
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation()
                onDelete?.()
              }}
              type="button"
              borderColor="danger"
            >
              <StyleActionButtonTitle tc="danger">
                Delete
              </StyleActionButtonTitle>
            </StyleActionButton>
          )}
        </>
      )}
    </StyleRow>
  )
}

export default TableActions
